<template>
	<div class="dashboard-container">
		<el-card class="sales-card">
			<div class="clearfix">
				<div class='fl headL'>
					<div class="headImg">
						<img src="../assets/img/1.jpg" width="110" height="110" />
					</div>
					<div class="headInfoTip">
						<p class="firstChild">Hi，祝你开心每一天！</p>
						<p class="lastChild">触圈文化传播有限公司</p>
					</div>
				</div>
				<div class="fr">
					<div class="headInfo numMs">
						<p class="fontS">{{arrlist.todayrunningwater}}</p>
						<p>今日流水</p>
					</div>
					<div class="headInfo numRz" @click="gourl(1)">
						<p class="fontS">{{arrlist.Cashwithdrawn}}</p>
						<p>提现待办</p>
					</div>
				</div>
			</div>
		</el-card>
		<el-card class="sales-card">
			<div class="clearfix">
				<div class='fl headL'>
				</div>
			</div>
		</el-card>
		<el-card class="box-card" style="margin-top:20px;">
			<div slot="header" class="header">
				<span>财务概览</span>
		 </div>
		 <div class="sidePerformance">
				<div class="performInfo">
					<ul class="clearfix">
						<li>
							<p class="radioInfo"><em class=" user"></em>{{arrlist.weekrunningwater}}</p>
							<p>平台本周流水</p>
						</li>
						<li>
							<p class="radioInfo"><em class="department"></em>{{arrlist.weekincome}}</p>
							<p>平台本周收益</p>
						</li>
						<li>
							<p class="radioInfo"><em class="company"></em>{{arrlist.weekpay}}</p>
							<p>平台本周支出</p>
						</li>
					</ul>
				</div>
				<!-- <div class="formit">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item>
							<el-radio label="1">平台支出</el-radio>
							<el-radio label="2">平台收入</el-radio>
						</el-form-item>
						<el-form-item style="float: right;">
							<el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期"
								end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" align="center"
								@change="chooseTimeRange">
							</el-date-picker>
						</el-form-item>
					</el-form>
				</div> -->
				<!--        <div class="chart">-->
				<!--          <div class="chartCon" id="chartConty"></div>-->
				<!--        </div>-->
			</div>
		</el-card>

	</div>
</template>

<script>
	import {getData} from '../api/home.js'
	export default{
		data(){
			return{
				arrlist:{
					todayrunningwater:0,
					Cashwithdrawn:12,
					weekrunningwater:123,
					weekincome:412,
					weekpay:22
				}
			}
		},
		mounted() {
			getData().then(res => {
			  this.arrlist = res
			})
		},
		methods:{
			gourl(e){
				//console.log(e);
				if(e == 1){
					// console.log('tx');

					this.$router.push('/recharge')
				}else{
					console.log('liu');
					this.$router.push('/runningwater')
				}
					
			}
		}
	}
	
</script>

<style  lang="less" scoped>
	.fr{
		cursor: pointer;
	}
.dashboard-container {
  margin: 10px;
  .headImg {
    float: left;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: #999;
  }

  .headInfoTip {
    padding: 25px 0 0;
    margin-left: 120px;
    p {
      padding: 0 0 15px;
      margin: 0;
      &.firstChild {
        font-size: 24px;
      }
      &.lastChild {
        font-size: 20px;
        color: #7f8c8d;
      }
    }
  }
}

.box-card {
  padding: 5px 10px;
  .header {
    span {
      color: #2c3e50;
      font-size: 24px;
    }
    .item {
      color: #97a8be;
      float: right;
      padding: 3px 0;
    }
  }
  .headTit {
    span {
      border-bottom: 4px solid #8a97f8;
      padding-bottom: 10px;
    }
  }
}


.sales-card {
	.clearfix{
		display: flex;
		justify-content: space-between;
	}
  position: relative;
  .header {
    position: absolute;
    right: 20px;
    top: 15px;
    z-index: 1;
  }
  .chart {
    widows: 100%;
    height: 300px;
  }
  .table {
    color: rgba(0, 0, 0, 0.65);
    h4 {
      color: #000;
      font-weight: 500;
    }
    ul {
      list-style: none;
      margin: 0px;
      padding: 0px;
      .row {
        margin-bottom: 10px;
      }
    }
    .circular {
      width: 20px;
      height: 20px;
      background-color: #314659;
      color: #fff;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      font-weight: 600;
      border-radius: 50%;
    }
    .light {
      background-color: #f5f5f5;
      color: rgba(0, 0, 0, 0.65);
    }
  }
}

.headInfo {
  width: 100px;
  height: 80px;
  border-radius: 50px;
  padding: 20px 0 0;
  margin: 0 15px;
  display: inline-block;
  color: #fff;
  text-align: center;
  p {
    padding: 0 0 5px;
    margin: 0;
    font-size: 16px;
  }
  .fontS {
    font-size: 30px;
  }
}
.headInfo.numMs {
  background: #8a97f8;
  box-shadow: 1px 1px 5px #8a97f8;
}
.headInfo.numRz {
  background: #ffc100;
  box-shadow: 1px 1px 5px #ffc100;
}
.headInfo.numZ {
  background: #fa8564;
  box-shadow: 1px 1px 5px #fa8564;
}
.advContent {
  background: #fff;
  border-radius: 5px 5px 0px 0px;
  .title {
    font-size: 16px;
    padding: 20px;
    font-weight: bold;
    border-bottom: solid 1px #ccc;
  }
  .contentItem {
    padding: 0 30px;
    min-height: 350px;
    .item {
      display: flex;
      padding:18px 0 10px;
      border-bottom: solid 1px #ccc;
      .col {
        color: #8a97f8;
      }
      img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        margin-right: 10px;
      }
      p{
        padding: 0 0 8px;
      }
    }
  }
}
.noticeList {
  margin: 0;
  padding: 0;
}
.sideNav,
.sideLink {
  padding: 30px 0 12px;
  li {
    border: 1px solid #ddd;
    border-radius: 5px;
    width: 137px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    margin: 0 15px 10px 0;
    font-size: 16px;
    float: left;
    a {
      display: block;
      height: 50px;
      color: #777;
    }
    &.addLinks{
      border: 1px dashed #8a97f8;
      a{
        color: #8a97f8;
      }
    }
  }
}
.sideLink {
  text-align: center;
  .icon {
    display: inline-block;
    width: 76px;
    height: 76px;
    background: url('../assets/img/1.jpg') no-repeat;
  }
  .iconGuide {
    background-position: 0 0;
  }
  .iconHelp {
    background-position: -224px 0;
  }
  .iconTechnology {
    background-position: -460px 0;
  }
}
.performInfo {
  border: 1px solid #e9e9e9;
  li {
    width: 33%;
    float: left;
    text-align: center;
    border-right: 1px solid #e9e9e9;
    cursor:pointer;
    &:last-child {
      border: 0 none;
    }
    padding: 10px 0;
    p {
      &:first-child {
        font-size: 40px;
      }
    }
  }
}

.performInfo li:hover {
  background:#4AB7BD;
  color: #fff;
}
.radioInfo {
  em {
      height: 6px;
    border-radius: 3px;
    vertical-align: middle;
    margin-right: 10px;
    &.user {
      background: #2ec7c9;
    }
    &.department {
      background: #b6a2de;
    }
    &.company {
      background: #5db3ef;
    }
  }
}
.formit{
  height:60px;
  padding-top: 12px;
}
.chartCon{
  border:1px solid #3d6df8;
  width:100%;
  height:450px;
}
</style>

